import { create } from 'zustand'

import { GenericContentModel } from '@/common/models/genericContent'

interface SelectedGenericContentStore {
  genericContent: GenericContentModel | null
  setGenericContent: (genericContent: GenericContentModel | null) => void
}

export const useSelectedGenericContentStore =
  create<SelectedGenericContentStore>((set) => ({
    genericContent: null,
    setGenericContent: (genericContent) => set({ genericContent }),
  }))
